module.exports = __webpack_public_path__ + "app/prepasrel/confirm-delete-2m-JB9n5.html";